import Modal from "@/components/shared/modal";
import { signIn } from "next-auth/react";
import {
  useState,
  Dispatch,
  SetStateAction,
  useCallback,
  useMemo,
} from "react";
import { LoadingDots, Google } from "@/components/shared/icons";
import Image from "next/image";
import { MAIN_SITE_URL } from "@/lib/constants";
import styles from "./sign-in-modal.module.css";

const SignInModal = ({
  showSignInModal,
  setShowSignInModal,
}: {
  showSignInModal: boolean;
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const [signInClicked, setSignInClicked] = useState(false);

  return (
    <Modal showModal={showSignInModal} setShowModal={setShowSignInModal}>
      <div className={styles.modalContainer}>
        <div className={styles.header}>
          <a href={MAIN_SITE_URL}>
            <Image
              src='/logo.png'
              alt='Logo'
              className={styles.logo}
              width={20}
              height={20}
            />
          </a>
          <h3 className={styles.title}>Sign In</h3>
        </div>

        <div className={styles.content}>
          <button
            disabled={signInClicked}
            className={styles.signInButton}
            onClick={() => {
              setSignInClicked(true);
              signIn("google", { callbackUrl: "/dashboard" });
            }}
          >
            {signInClicked ? (
              <LoadingDots color='#808080' />
            ) : (
              <>
                <Google className='h-5 w-5' />
                <p>Sign In with Google</p>
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export function useSignInModal() {
  const [showSignInModal, setShowSignInModal] = useState(false);

  const SignInModalCallback = useCallback(() => {
    return (
      <SignInModal
        showSignInModal={showSignInModal}
        setShowSignInModal={setShowSignInModal}
      />
    );
  }, [showSignInModal, setShowSignInModal]);

  return useMemo(
    () => ({ setShowSignInModal, SignInModal: SignInModalCallback }),
    [setShowSignInModal, SignInModalCallback],
  );
}
